import React, { useEffect, useState } from "react";
import AppModal from "./AppModal";

const LeaveModal = ({
  show,
  setShow,
  editData = null,
  viewMode = false,
}) => {
  const initialState = {
    employee_name: "",
    leave_type: "Casual Leave",
    from_date: "",
    to_date: "",
    total_days: "",
    reason: "",
    status: "Pending",
  };

  const [formData, setFormData] = useState(initialState);

  // Edit Data Fill
  useEffect(() => {
    if (editData) {
      setFormData({
        ...initialState,
        ...editData,
      });
    } else {
      setFormData(initialState);
    }
  }, [editData, show]);

  // Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Calculate Total Days
  useEffect(() => {
    if (formData.from_date && formData.to_date) {
      const from = new Date(formData.from_date);
      const to = new Date(formData.to_date);

      const diffTime = to - from;

      const diffDays =
        diffTime >= 0
          ? Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1
          : 0;

      setFormData((prev) => ({
        ...prev,
        total_days: diffDays,
      }));
    }
  }, [formData.from_date, formData.to_date]);

  // Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);

    setShow(false);
  };

  return (
    <AppModal
      show={show}
      setShow={setShow}
      size="modal-md"
      title={
        viewMode
          ? "View Leave"
          : editData
          ? "Edit Leave"
          : "Add Leave"
      }
      footer={
        <>
          <button
            className="btn btn-danger"
            onClick={() => setShow(false)}
          >
            Cancel
          </button>

          {!viewMode && (
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              {editData ? "Update Leave" : "Create Leave"}
            </button>
          )}
        </>
      }
    >
      <form>
        <div className="row">
          {/* Employee Name */}
          <div className="col-md-6 mb-3">
            <label className="form-label">
              Employee Name
            </label>

            <input
              type="text"
              className="form-control"
              name="employee_name"
              placeholder="Enter employee name"
              value={formData.employee_name}
              onChange={handleChange}
              disabled={viewMode}
            />
          </div>

          {/* Leave Type */}
          <div className="col-md-6 mb-3">
            <label className="form-label">
              Leave Type
            </label>

            <select
              className="form-select"
              name="leave_type"
              value={formData.leave_type}
              onChange={handleChange}
              disabled={viewMode}
            >
              <option value="Casual Leave">
                Casual Leave
              </option>

              <option value="Sick Leave">
                Sick Leave
              </option>

              <option value="Paid Leave">
                Paid Leave
              </option>

              <option value="Emergency Leave">
                Emergency Leave
              </option>
            </select>
          </div>

          {/* From Date */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              From Date
            </label>

            <input
              type="date"
              className="form-control"
              name="from_date"
              value={formData.from_date}
              onChange={handleChange}
              disabled={viewMode}
            />
          </div>

          {/* To Date */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              To Date
            </label>

            <input
              type="date"
              className="form-control"
              name="to_date"
              value={formData.to_date}
              onChange={handleChange}
              disabled={viewMode}
            />
          </div>

          {/* Total Days */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Total Days
            </label>

            <input
              type="number"
              className="form-control"
              name="total_days"
              value={formData.total_days}
              readOnly
            />
          </div>

          {/* Reason */}
          <div className="col-md-12 mb-3">
            <label className="form-label">
              Reason
            </label>

            <textarea
              rows="4"
              className="form-control"
              name="reason"
              placeholder="Write leave reason..."
              value={formData.reason}
              onChange={handleChange}
              disabled={viewMode}
            ></textarea>
          </div>

          {/* Status */}
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Status
            </label>

            <select
              className="form-select"
              name="status"
              value={formData.status}
              onChange={handleChange}
              disabled={viewMode}
            >
              <option value="Pending">
                Pending
              </option>

              <option value="Approved">
                Approved
              </option>

              <option value="Rejected">
                Rejected
              </option>
            </select>
          </div>
        </div>
      </form>
    </AppModal>
  );
};

export default LeaveModal;